import React from 'react';
import './WelcomeModal.css';

const FREE_PERKS = [
  'Frequency charts for every number',
  'Hot & Cold tracker',
  'Full draw history',
  'Heatmap visualization',
  'Random number picker',
  'Powerball & Mega Millions',
];

export default function WelcomeModal({ onSignIn, onSignUp, onDismiss }) {
  return (
    <div className="wm-overlay">
      <div className="wm-modal">
        <button className="wm-close" onClick={onDismiss} aria-label="Dismiss">✕</button>

        <div className="wm-header">
          <h2 className="wm-title">Welcome to LottoPickle</h2>
          <p className="wm-sub">Create a free account to save your preferences and unlock Premium features.</p>
        </div>

        <ul className="wm-perks">
          {FREE_PERKS.map((p) => (
            <li key={p} className="wm-perk">
              <span className="wm-check">✓</span> {p}
            </li>
          ))}
        </ul>

        <div className="wm-actions">
          <button className="wm-btn-primary" onClick={onSignUp}>Create free account</button>
          <button className="wm-btn-secondary" onClick={onSignIn}>Sign in</button>
        </div>

        <button className="wm-skip" onClick={onDismiss}>Continue without an account</button>
      </div>
    </div>
  );
}
